// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YtbH","expireSoon":"styles_expireSoon__3wlyp"};